import { createFileRoute, redirect } from '@tanstack/react-router'
import { useAuthStore } from '@/features/auth'
import { IncentiveManagementPage } from '@/features/incentive-management'

export const Route = createFileRoute('/_authenticated/admin/incentive/')({
  beforeLoad: () => {
    const { auth } = useAuthStore.getState()
    if (auth.user?.role !== 'admin' && auth.user?.role !== 'super_admin') {
      throw redirect({ to: '/403' })
    }
  },
  component: IncentiveManagementPage,
})
